// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb52632c","453":"557d4268","455":"1f017282","977":"e7de8c11"}[chunkId] + ".chunk.js";
};